import CardPage from 'screens/Card/Card';

export default CardPage;
